import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface RegistryItem {
  id: string;
  name: string;
  description: string;
  price: number;
  image_url?: string;
  registry_url: string;
  category: string;
  type: "item" | "external_link";
  purchased: boolean;
  purchased_by_name?: string;
  purchased_by_id?: string;
  purchase_note?: string;
  created_at: string;
  updated_at: string;
}

export interface Invitation {
  id: string;
  code: string;
  guest_names: string;
  ceremony: boolean;
  luncheon: boolean;
  reception: boolean;
  rsvp_ceremony: boolean;
  rsvp_luncheon: boolean;
  rsvp_reception: boolean;
  dietary_restrictions?: string;
  plus_one: boolean;
  family_allowed: boolean;
  family_attending?: number;
  bringing_plus_one?: boolean;
  plus_one_name?: string;
  printed_code?: boolean;
  finalized?: boolean;
  sent?: boolean;
  created_at: string;
  updated_at: string;
}
